export default __webpack_public_path__ + "static/media/SAML_Configuration_Step1.12d6d361.png";